import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import Warning from "services/WarningService";
import dayjs from "dayjs";

import {PAGE_INDEX, PAGE_SIZE} from "../../constanst";

export const warningSearchApi = createAsyncThunk(
  "warning/warningSearchApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await Warning.warningSearchApi(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);


export const handleWarning = createAsyncThunk(
  "warning/handleWarning",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await Warning.handleWarning(data);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title")
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const getWarningDetail = createAsyncThunk(
  "warning/getWarningDetail",
  async (id, { rejectWithValue }) => {
    try {
      const response = await Warning.getWarningDetail(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  }
);

export const pinnedWarning = createAsyncThunk(
    "warning/pinnedWarning",
    async (data, { rejectWithValue }) => {
      try {
        const { onSuccess } = data;
        delete data.onSuccess;
        const response = await Warning.pinnedWarning(data);
        if (onSuccess) onSuccess(response.data);
        openNotification(
            "success",
            Utils.setLocale("admin.settings.popup.notification.success"),
            Utils.setLocale("admin.settings.popup.notification.title")
        );
        return response.data;
      } catch (err) {
        return rejectWithValue(err.message || "Error");
      }
    }
);

export const processingWarning = createAsyncThunk(
    "warning/processingWarning",
    async (data, { rejectWithValue }) => {
      try {
        const { onSuccess } = data;
        delete data.onSuccess;
        const response = await Warning.processingWarning(data);
        if (onSuccess) onSuccess(response.data);
        openNotification(
            "success",
            Utils.setLocale("admin.settings.popup.notification.success"),
            Utils.setLocale("admin.settings.popup.notification.title")
        );
        return response.data;
      } catch (err) {
        return rejectWithValue(err.message || "Error");
      }
    }
);


const initialState = {
  loading: false,
  warningList: [],
  countUnhandle: 0,
  countHandled: 0,
  countDanger: 0,
  totalCount: 0,
  filterWarning:{
      // isGetALl:true
      PageSize: PAGE_SIZE,
      PageIndex: PAGE_INDEX,
      TextSearch: null,
      StartDate: dayjs().format("YYYY-MM-DD"),
      EndDate: dayjs().add(1, 'day').format("YYYY-MM-DD"),
      Status: -1,
      WarningType: -1,
      WarningLevel: -1,
      ActiveTab: 0,
  }
};
export const warningSlice = createSlice({
  name: "warning",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setFilterWarning: (state, action) => {
      state.filterWarning = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(warningSearchApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(warningSearchApi.fulfilled, (state, action) => {
        state.loading = false;
        state.warningList = action.payload.warnings;
        state.countUnhandle = action.payload.countUnhandle;
        state.countHandled = action.payload.countHandled;
        state.countDanger = action.payload.countDanger;
        state.totalCount = action.payload.totalCount;
      })
      .addCase(warningSearchApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(handleWarning.pending, (state) => {
        state.loading = true;
      })
      .addCase(handleWarning.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(handleWarning.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setFilterWarning } = warningSlice.actions;

export default warningSlice.reducer;
